export class MenuNavUtils {
  static getMenuId(node) {
    let id = false;
    let role = node.getAttribute("role");

    while (node && role !== "menu" && role !== "menubar" && role !== "group") {
      node = node.parentNode;
      if (node) {
        role = node.getAttribute("role");
      }
    }

    if (node) {
      id = role + "-" + this.getIdFromAriaLabel(node);
    }

    return id;
  }

  static getIdFromAriaLabel(node) {
    let id = node.getAttribute("aria-label");
    if (id) {
      id = id.trim().toLowerCase().replace(" ", "-").replace("/", "-");
    }
    return id;
  }

  static getMenuOrientation(node) {
    let orientation = node.getAttribute("aria-orientation");
    if (!orientation) {
      const role = node.getAttribute("role");
      switch (role) {
        case "menubar":
          orientation = "horizontal";
          break;
        case "menu":
          orientation =
            String(node?.classList).indexOf("--columns") > -1
              ? "horizontal"
              : "vertical";
          break;
        default:
          break;
      }
    }

    return orientation;
  }

  static hasPopup(menuitem) {
    return menuitem.getAttribute("aria-haspopup") === "true";
  }

  static isTopLevel(menuitem) {
    return menuitem.getAttribute("aria-toplevel") === "true";
  }


  static hasLink(menuitem) {
    return menuitem.getAttribute("href") !== "#";
  }

  static isOpen(menuitem) {
    return menuitem.getAttribute("aria-expanded") === "true";
  }

  static isInFullContentView(menuitem) {
    return menuitem.closest('div[role=group] div[role=menu]') !== null;
  }

  static getMenubarId(domId) {
    return this.getMenuId(document.querySelector(`#${domId}[role="menubar"]`));
  }

  static doesNotContain(popup, menuitem) {
    if (menuitem) {
      return !popup.nextElementSibling.contains(menuitem);
    }
    return true;
  }

  static isPrintableCharacter(str) {
    return str.length === 1 && str.match(/\S/);
  }

  static getMenu(menuitem, onlyGroup = false) {
    let menu = menuitem;
    let role = menuitem.getAttribute("role");

    while ((onlyGroup && role !== "group") || (!onlyGroup && menu && role !== "menu" && role !== "group" && role !== "menubar")) {
      menu = menu.parentNode;
      if (menu) {
        role = menu.getAttribute("role");
      }
    }

    return menu;
  }

  static createDomId(domNode) {
    const id = `nav-${Math.ceil(Math.random()*1000)}-${(+new Date())}`;
    domNode?.setAttribute('id', id);
    return id;
  }

  static getDomId(domNode) {
    return domNode?.getAttribute('id');
  }

  static isDesktopScreenSize() {
    const BREAKPOINT_XLARGE_SCREEN_SIZE = 1360; // (1200 + 80 + 80 from abstracts/_breakpoints.scss 'xlarge')
    return window.innerWidth >= BREAKPOINT_XLARGE_SCREEN_SIZE;
  }
}
